<template>

    <v-card>
        <v-card-title>Manage Quick Loads</v-card-title>
        <v-divider />
        <v-card-text>

            <v-simple-table dark height="400" fixed-header>
                <template v-slot:default>
                <thead>
                    <tr>
                        <th class="text-left">Name</th>
                        <th class="text-left">Days Back</th>
                        <th class="text-left">Load</th>
                        <th class="text-left">Delete</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(quickload, index) in quickloadConfigsClone" :key="index">
                        <td>
                            <span>{{ quickload.name }}</span>
                        </td>
                        <td>
                            <span>{{ quickload.daysBack }}</span>
                        </td>
                        <td><v-btn icon @click="loadQuickload(quickload)"><v-icon style="transform: scaleX(-1)">mdi-keyboard-return</v-icon></v-btn></td>
                        <td><v-btn icon @click="quickloadConfigsClone.splice(index, 1)"><v-icon>mdi-delete</v-icon></v-btn></td>
                    </tr>
                </tbody>
                </template>
            </v-simple-table>

            <v-form ref="newQuickloadConfigForm" :lazy-validation="true" v-model="newQuickloadConfigFormValid">
                <v-row>
                    <v-col cols="7">
                        <v-text-field v-model="newQuickloadName" color="#c42111" label="Quick Load Name" :rules="[validation.required(newQuickloadName), validation.unique(newQuickloadName, quickloadConfigsClone)]" />
                    </v-col>
                    <v-col cols="3">
                        <v-text-field v-model="newQuickloadDaysBack" color="#c42111" label="Days Back" type="number" min="0" :rules="[validation.posInt(newQuickloadDaysBack)]" />
                    </v-col>
                    <v-col cols="2">
                        <v-btn class="ml-2 mt-5" fab dark x-small color="#c42111" title="Add" @click="addQuickload">
                            <v-icon>mdi-plus</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-form>

        </v-card-text>
        <v-divider />
        <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn text @click="$emit('cancel')">Cancel</v-btn>
            <v-btn text @click="saveQuickloadsClick">Save</v-btn>
        </v-card-actions>
    </v-card>
    
</template>

<script>
export default {
    name: 'ManageQuickloads',
    props: ['reportDetails'],
    components: {

    },
    data: () => ({
        quickloadConfigsClone: [],
        newQuickloadName: '',
        newQuickloadDaysBack: '',
        newQuickloadConfigFormValid: true,
        validation: {
            required: (value) => ((value || value === 0) ? true : false) || `Name is required`,
            unique: (value, quickloads) => (!value || !quickloads.some(q => {return (q.name == value.trim())})) || 'This name is already is use',
            posInt: (value) => (Number.isInteger(Number(value)) && value > 0) || `Value must be a positive integer`
        }
    }),

    computed: {

    },

    methods: {
        addQuickload: function() {
            if(this.$refs.newQuickloadConfigForm.validate()) {
                this.quickloadConfigsClone.push({
                    name: this.newQuickloadName,
                    daysBack: this.newQuickloadDaysBack,
                    params: this.$props.reportDetails.rpt_params
                });
                this.newQuickloadName = '';
                this.newQuickloadDaysBack = '';
                this.$refs.newQuickloadConfigForm.resetValidation();
            }
        },

        loadQuickload: function(quickload) {
            this.$emit('apply', quickload);
        },

        saveQuickloadsClick: function() {
            this.$emit('save', this.quickloadConfigsClone);
        }
    },

    mounted() {
        this.quickloadConfigsClone = JSON.parse(JSON.stringify(this.$props.reportDetails.quickload_configs));
        // Look for date range param to set "daysBack" initial value
        for(let reportParam of this.$props.reportDetails.rpt_params) {
            if(reportParam.rpt_param_type == 'date_range') {
                let startDate = TELSA.moment(reportParam.selectedValue.split(' ')[0]);
                let endDate = TELSA.moment(reportParam.selectedValue.split(' ')[1]);
                this.newQuickloadDaysBack = TELSA.moment.duration(endDate.diff(startDate)).asDays();
                break;
            }
        }
    }

  
};
</script>
